document.addEventListener('DOMContentLoaded', function () {
  var makers = [
    'AUROMEDICS PHARMA LLC',
    'AVET PHARMACEUTICALS INC',
    'AVET PHARMACEUTICALS, INC.',
    'FRESENIUS KABI USA, LLC',
    'FRESENIUS KABI',
    'HOSPIRA, INC.',
    'HOSPIRA INC.',
    'HOSPIRA',
    'AMNEAL PHARMACEUTICALS, LLC',
    'AMNEAL PHARMACEUTICALS LLC',
    'AMNEAL',
    'SAGENT PHARMACEUTICALS, INC.',
    'SAGENT PHARMACEUTICALS INC.',
    'SAGENT',
    'PFIZER, INC.',
    'PFIZER INC.',
    'PFIZER',
    'BAXTER HEALTHCARE CORPORATION',
    'BAXTER',
    'B. BRAUN',
    'B.BRAUN',
    'ICU MEDICAL, INC.',
    'ICU MEDICAL',
    'TEVA PHARMACEUTICALS USA, INC.',
    'TEVA',
    'MCKESSON CORPORATION',
    'MCKESSON',
    'AMERICAN REGENT, INC.',
    'AMPHASTAR PHARMACEUTICALS, INC.',
    'AMPHASTAR',
    'MAJOR PHARMACEUTICALS',
    'BAYER HEALTHCARE PHARMACEUTICALS INC.',
    'BRACCO DIAGNOSTICS INC.',
    'GERI-CARE',
    'LIEBEL-FLARSHEIM COMPANY LLC',
    'DEVATIS, INC.',
    'X-GEN',
    'GLAXO SMITH KLINE',
    'BOEHRINGER INGELHEIM PHARMACEUTICALS, INC.',
    'BOEHRINGER INGELHEIM ANIMAL HEALTH USA INC.',
    'ELANCO HEALTH'
  ];

  function cleanMakerName(value) {
    return String(value || '')
      .replace(/\|+/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\s+,/g, ',')
      .replace(/[,\s]+$/g, '')
      .trim()
      .toUpperCase();
  }

  function inferProductMaker(rawTitle) {
    if (!rawTitle) return '';
    var title = cleanMakerName(String(rawTitle).replace(/\bNDC\s*#?\s*[:\-]?\s*[A-Z0-9][A-Z0-9.\-\/]*/gi, ''));
    var abbreviations = [
      { pattern: /\bPFZ\b/, maker: 'PFIZER' },
      { pattern: /\bHSP\b/, maker: 'HOSPIRA' },
      { pattern: /\bFKB\b/, maker: 'FRESENIUS KABI' }
    ];

    for (var abbrIndex = 0; abbrIndex < abbreviations.length; abbrIndex += 1) {
      if (abbreviations[abbrIndex].pattern.test(title)) return abbreviations[abbrIndex].maker;
    }

    for (var index = 0; index < makers.length; index += 1) {
      var maker = cleanMakerName(makers[index]);
      if (title.indexOf(maker) !== -1) return maker;
    }

    var suffixMatch = title.match(/\b([A-Z][A-Z&'.-]*(?:\s+[A-Z][A-Z&'.-]*){0,4}\s+(?:PHARMA(?:CEUTICALS)?|HEALTHCARE|MEDICAL|LABORATOR(?:Y|IES)|DIAGNOSTICS|THERAPEUTICS)(?:\s+[A-Z][A-Z&'.-]*){0,4}\s+(?:INC|LLC|LTD|CORP|CORPORATION|COMPANY|CO)\.?)$/);
    if (suffixMatch) return cleanMakerName(suffixMatch[1]);

    return '';
  }

  function cleanProductTitle(rawTitle) {
    if (!rawTitle) return '';
    var title = String(rawTitle)
      .replace(/\s+/g, ' ')
      .replace(/\b(?:NDC|MFG|MFR|P\/N)\s*#?\s*[:\-]?\s*[A-Z0-9][A-Z0-9.\-\/]*/gi, '')
      .replace(/\|+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    makers.forEach(function (maker) {
      title = title.replace(new RegExp('\\s*' + maker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\.?\\s*$', 'i'), '');
    });

    title = title
      .replace(/\s+[A-Z0-9 .,&'/-]*(?:PHARMA(?:CEUTICALS)?|HEALTHCARE|MEDICAL|LABORATOR(?:Y|IES)|DIAGNOSTICS|THERAPEUTICS)[A-Z0-9 .,&'/-]*(?:INC|LLC|LTD|CORP|CORPORATION|COMPANY|CO)\.?\s*$/i, '')
      .replace(/\s+[A-Z0-9 .,&'/-]+(?:INC|LLC|LTD|CORP|CORPORATION|COMPANY|CO)\.?\s*$/i, '')
      .replace(/\s+,/g, ',')
      .replace(/,\s*$/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    return title;
  }

  function normalizeNdc(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function fetchProductSpecData() {
    if (!window.CrownProductSpecDataUrl || window.CrownProductSpecDataPromise) {
      return window.CrownProductSpecDataPromise || Promise.resolve({});
    }

    window.CrownProductSpecDataPromise = fetch(window.CrownProductSpecDataUrl)
      .then(function (response) {
        return response.ok ? response.json() : {};
      })
      .catch(function () {
        return {};
      });

    return window.CrownProductSpecDataPromise;
  }

  function tableRowsByLabel(table) {
    var rows = {};
    table.querySelectorAll('tr').forEach(function (row) {
      var label = row.querySelector('th');
      var value = row.querySelector('td');
      if (!label || !value) return;
      rows[label.textContent.replace(/\s+/g, ' ').trim().toUpperCase()] = value;
    });
    return rows;
  }

  function applyProductSpecData(data) {
    document.querySelectorAll('.product-specifications').forEach(function (table) {
      var rows = tableRowsByLabel(table);
      var ndcCell = rows['NDC #'];
      var spec = data[normalizeNdc(ndcCell && ndcCell.textContent)];
      if (!spec) return;

      if (rows.MANUFACTURER && spec.manufacturer && spec.manufacturer !== 'Confirm with Crown') {
        rows.MANUFACTURER.textContent = spec.manufacturer;
      }

      if (rows['MFG #'] && spec.mfgNumber && spec.mfgNumber !== 'Confirm with Crown') {
        rows['MFG #'].textContent = spec.mfgNumber;
      }

      if (rows.UOM && spec.uom && rows.UOM.textContent.replace(/\s+/g, ' ').trim() === 'Confirm with Crown') {
        rows.UOM.textContent = spec.uom;
      }
    });

    document.querySelectorAll('[data-product-maker-ndc]').forEach(function (element) {
      var spec = data[normalizeNdc(element.dataset.productMakerNdc)];
      if (!spec || !spec.manufacturer || spec.manufacturer === 'Confirm with Crown') return;
      element.textContent = spec.manufacturer;
      element.hidden = false;
    });

    document.querySelectorAll('[data-product-mfg-ndc]').forEach(function (element) {
      var spec = data[normalizeNdc(element.dataset.productMfgNdc)];
      if (!spec || !spec.mfgNumber || spec.mfgNumber === 'Confirm with Crown') return;
      element.textContent = spec.mfgNumber;
      element.hidden = false;

      var label = element.previousElementSibling;
      if (label && label.hasAttribute('data-product-mfg-label')) {
        label.hidden = false;
      }
    });
  }

  document.querySelectorAll('[data-clean-product-title]').forEach(function (element) {
    var cleanTitle = cleanProductTitle(element.dataset.cleanProductTitle || element.textContent);
    if (cleanTitle) element.textContent = cleanTitle;
  });

  document.querySelectorAll('[data-product-maker-title]').forEach(function (element) {
    var valueElement = element.querySelector('span:last-child');
    var maker = cleanMakerName(valueElement ? valueElement.textContent : element.textContent) || inferProductMaker(element.dataset.productMakerTitle);
    if (maker && maker !== 'CONFIRM WITH CROWN') {
      element.textContent = maker;
    } else {
      element.hidden = true;
    }
  });

  fetchProductSpecData().then(applyProductSpecData);

  var body = document.querySelector('[data-rfq-body]');
  function refreshQuoteCartBody() {
    if (!body) return;

    var rows = Array.from(document.querySelectorAll('[data-rfq-item]')).map(function (row) {
      var quantityInput = row.querySelector('[data-rfq-quantity-input]');
      var quantity = quantityInput ? quantityInput.value : row.dataset.quantity;
      return '- ' + cleanProductTitle(row.dataset.title) + ' | NDC: ' + (row.dataset.ndc || 'N/A') + ' | Quantity: ' + quantity;
    });

    body.value = 'Please prepare a quote for:\n\n' + rows.join('\n');
  }

  refreshQuoteCartBody();

  document.querySelectorAll('[data-rfq-quantity-input]').forEach(function (input) {
    input.addEventListener('input', refreshQuoteCartBody);
    input.addEventListener('change', refreshQuoteCartBody);
  });

  var openAccountForm = document.getElementById('OpenAccountForm');
  if (openAccountForm) {
    var shippingSame = document.getElementById('ShippingSame');
    var accountLicenseFile = document.getElementById('LicenseFile');
    var accountAddressFields = {
      BillingAddress1: 'ShippingAddress1',
      BillingAddress2: 'ShippingAddress2',
      BillingCity: 'ShippingCity',
      BillingState: 'ShippingState',
      BillingZip: 'ShippingZip'
    };

    function copyBillingToShipping() {
      if (!shippingSame) return;
      Object.keys(accountAddressFields).forEach(function (sourceId) {
        var source = document.getElementById(sourceId);
        var target = document.getElementById(accountAddressFields[sourceId]);
        if (!source || !target) return;
        if (shippingSame.checked) target.value = source.value;
        target.readOnly = shippingSame.checked;
      });
    }

    if (shippingSame) {
      shippingSame.addEventListener('change', copyBillingToShipping);
      Object.keys(accountAddressFields).forEach(function (sourceId) {
        var source = document.getElementById(sourceId);
        if (!source) return;
        source.addEventListener('input', function () {
          if (shippingSame.checked) copyBillingToShipping();
        });
      });
    }

    openAccountForm.addEventListener('submit', function (event) {
      if (accountLicenseFile && accountLicenseFile.files[0] && accountLicenseFile.files[0].size > 2 * 1024 * 1024) {
        event.preventDefault();
        accountLicenseFile.setCustomValidity('Maximum file size is 2 MB.');
        accountLicenseFile.reportValidity();
        accountLicenseFile.setCustomValidity('');
      }
    });
  }

  var licenseAppForm = document.querySelector('[data-license-app-form]');
  if (licenseAppForm) {
    var licenseStatus = licenseAppForm.querySelector('[data-license-submit-status]');
    var licenseFrame = document.querySelector('iframe[name="' + licenseAppForm.getAttribute('target') + '"]');
    var licenseSubmitted = false;

    function setLicenseStatus(message, statusClass) {
      if (!licenseStatus) return;
      licenseStatus.textContent = message;
      licenseStatus.className = 'form-status ' + statusClass;
      licenseStatus.hidden = false;
    }

    licenseAppForm.addEventListener('submit', function (event) {
      var fileInput = licenseAppForm.querySelector('[name="license_file"]');
      var selectedFile = fileInput && fileInput.files && fileInput.files[0];

      if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
        event.preventDefault();
        setLicenseStatus('Please upload a PDF, JPG, or PNG file that is 2 MB or smaller.', 'form-status-error');
        return;
      }

      licenseSubmitted = true;
      setLicenseStatus('Uploading your license. Please wait...', 'form-status-info');
    });

    if (licenseFrame) {
      licenseFrame.addEventListener('load', function () {
        if (!licenseSubmitted) return;
        licenseSubmitted = false;
        setLicenseStatus('Thank you. Your updated license has been submitted to Crown Pharmaceuticals.', 'form-status-success');
        licenseAppForm.reset();
      });
    }
  }

  var resourceLoginForm = document.querySelector('[data-resource-login-form]');
  var resourceLoginError = document.querySelector('[data-resource-login-error]');
  var resourceSignOut = document.querySelector('[data-resource-sign-out]');
  var resourceLoginPath = /\.html$/i.test(window.location.pathname) ? 'login.html' : '/pages/login';
  var resourceLoginView = document.querySelector('[data-resource-login-view]');
  var resourceAuthView = document.querySelector('[data-resource-auth-view]');
  var resourceCredentialHashes = [
    '0c4589633c3763d6f4ea87ef6ec5fd02672782f4c720cbda3e7c1a6c2536019b',
    'b6a19e3e0c2c80e7e240caf2685da0971d3dd13772bacee93805b23af8d589ee',
    '57a03b58266cd80589728648e67485f1163d1ac1131441cf2057ce88f1715e1a'
  ];

  function sha256Hex(value) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.reject(new Error('Crypto API unavailable'));
    }

    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function setResourceLoginView(isLoggedIn) {
    if (resourceLoginView) resourceLoginView.hidden = isLoggedIn;
    if (resourceAuthView) resourceAuthView.hidden = !isLoggedIn;
  }

  if (resourceAuthView) {
    setResourceLoginView(sessionStorage.getItem('crownResourceCenterLogin') === '1');
  }

  if (resourceLoginForm) {
    resourceLoginForm.addEventListener('submit', function (event) {
      var username = resourceLoginForm.querySelector('[name="employee_username"]').value.trim().toLowerCase();
      var password = resourceLoginForm.querySelector('[name="employee_password"]').value;
      event.preventDefault();

      sha256Hex(username + ':' + password).then(function (hash) {
        if (resourceCredentialHashes.indexOf(hash) === -1) {
          if (resourceLoginError) resourceLoginError.hidden = false;
          return;
        }

        sessionStorage.setItem('crownResourceCenterLogin', '1');
        setResourceLoginView(true);
        if (resourceLoginError) resourceLoginError.hidden = true;
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', resourceLoginForm.getAttribute('action') || (resourceLoginPath + '#resource-center'));
        } else {
          window.location.href = resourceLoginForm.getAttribute('action') || (resourceLoginPath + '#resource-center');
        }
      }).catch(function () {
        if (resourceLoginError) {
          resourceLoginError.textContent = 'Secure login is unavailable in this browser. Please try again.';
          resourceLoginError.hidden = false;
        }
      });
    });
  }

  if (!resourceLoginView && document.querySelector('.employee-resource-section') && sessionStorage.getItem('crownResourceCenterLogin') !== '1') {
    window.location.replace(resourceLoginPath);
    return;
  }

  if (resourceSignOut) {
    resourceSignOut.addEventListener('click', function (event) {
      sessionStorage.removeItem('crownResourceCenterLogin');
      if (resourceAuthView) {
        event.preventDefault();
        setResourceLoginView(false);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', resourceLoginPath);
        }
      }
    });
  }

  var chat = document.querySelector('[data-live-chat]');
  if (!chat) return;
  var panel = chat.querySelector('.live-chat-panel');
  var toggle = chat.querySelector('[data-live-chat-toggle]');
  var close = chat.querySelector('[data-live-chat-close]');
  var start = chat.querySelector('[data-live-chat-start]');
  var form = chat.querySelector('[data-live-chat-form]');
  var usesChatwoot = chat.dataset.liveChatProvider === 'chatwoot';
  function setChatOpen(open) {
    chat.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close chat' : 'Open chat');
  }
  toggle.addEventListener('click', function () { setChatOpen(!chat.classList.contains('is-open')); });
  close.addEventListener('click', function () { setChatOpen(false); });
  start.addEventListener('click', function () {
    if (usesChatwoot && window.$chatwoot) {
      setChatOpen(false);
      window.$chatwoot.toggle('open');
      return;
    }
    start.closest('.live-chat-card').hidden = true;
    form.hidden = false;
    form.querySelector('input:not([type="hidden"])').focus();
  });
});
